// Formatting samples only. Never use this module as a submission schema.
export type PaymentPreviewMethod = "credit-card" | "ach";

export const PAYMENT_PREVIEW_TERMS = "The undersigned applicant certifies all information above is accurate and truthful. By signing this document, you are agreeing to all terms of sale and payment of the product ordered. Applicant authorizes Premier Pharmaceuticals, LLC to check DUNS and/or credit report if applicable. All customers of Premier Pharmaceuticals, LLC are subject to 2% late fees (24% annually) accrued monthly to invoice total if not paid within net terms agreed to above.";
export const PAYMENT_PREVIEW_FEE_NOTE = "Please note for credit card choice of payment: ONLY due on receipt financial terms will be exempt from a 3% transaction fee.";
export const PAYMENT_PREVIEW_ACH_AUTHORIZATION = 'I/we hereby authorize Premier Pharmaceuticals LLC ["COMPANY"], to initiate debit entries to my/our account indicated below, and the financial institution named below ["BANK"], to debit same to such account.';
export const PAYMENT_PREVIEW_ACH_TERMINATION = "This authority is to remain in full force and effect until COMPANY and BANK have received written notification from me (or either of us) of its termination in such time and in such manner as to afford COMPANY and BANK a reasonable opportunity to act on it.";

export const PAYMENT_PREVIEW_SAMPLE = {
  companyName: "SAMPLE — Example Healthcare LLC",
  cardholder: "Taylor Example",
  cardNumber: "4242 4242 4242 4242",
  expiration: "12/2030",
  cvv: "DEMO",
  signerName: "Taylor Example",
  title: "Practice Manager",
  date: "2026-10-20",
  bankName: "Example Bank",
  accountType: "Checking",
  accountNumber: "000012345678",
  routingNumber: "000000000",
  bankAddress: "100 Example Street",
  bankCityStateZip: "Boise, ID 83709",
} as const;
